var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpenPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1039 40.3093C17.241 37.1254 20.257 35 23.6379 35H68.3241C71.0902 35 73.0214 37.7404 72.0911 40.3453L64.9482 60.3453C64.3796 61.9373 62.8717 63 61.1812 63H10.8381C9.45505 63 8.48946 61.6298 8.95463 60.3273L16.1039 40.3093Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35V29C64 26.7909 62.2091 25 60 25H31.3992C31.0329 25 30.689 24.8233 30.4757 24.5254L26.2841 18.6713C25.533 17.6223 24.322 17 23.0318 17H12C9.79086 17 8 18.7909 8 21V59C8 59.9655 8.34209 60.8511 8.91167 61.5423",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenPath);
export default __webpack_public_path__ + "static/media/folder-open_path.5ec04f047c07a69ca7c9661f67b8dfa3.svg";
export { ForwardRef as ReactComponent };